<template>
  <div style="
      display: inline-block;
      width: 100%;
      height: 100%;
      background-color: #eee;">
   
        <live_view_l name="l1"></live_view_l>
   </div>
</template>

<script>
import axios from 'axios'
import live_view_l from './live_view_l'

export default {
  name: 'live_view_split',
  components: {
    live_view_l
  },
}
</script>
